
import { ValidateStringInput } from "../directives/validate-string-input.function";

export enum ExportMethods {
  Files = 'Files',
  Folder = 'Folder',
  Zip = 'Zip'
}